import { useStoreSsPlayer } from '~/stores/softswiss/player';
import { getCookieValue, rootDomain } from '~/utils/cookie';

export const useCookieUserId = () => {
  const saveUserId = () => {
    const domain = rootDomain(document.location.hostname);

    const playerId = useStoreSsPlayer().playerId;

    window.document.cookie = `UserID=${playerId};Max-Age=63158400;Domain=${domain};Path=/`;

    window.localStorage.setItem('UserID', playerId?.toString() || '');
  };

  const checkUserId = () => {
    const domain = rootDomain(document.location.hostname);
    const userID = getCookieValue('UserID');
    const userIDFromLocalStorage = window.localStorage.getItem('UserID');

    const playerId = useStoreSsPlayer().playerId;

    if (userID !== playerId?.toString()) {
      window.document.cookie = `UserID=${playerId};Max-Age=63158400;Domain=${domain};Path=/`;
    }

    if (userIDFromLocalStorage?.toString() !== playerId?.toString()) {
      window.localStorage.setItem('UserID', playerId?.toString() || '');
    }
  };

  const init = () => {
    if (!window || !import.meta.browser) {
      return;
    }

    const userID = getCookieValue('UserID');
    const userIDFromLocalStorage = window.localStorage.getItem('UserID');

    const domain = rootDomain(document.location.hostname);

    if (userID && userIDFromLocalStorage !== userID) {
      window.localStorage.setItem('UserID', userID);
      return;
    }

    if (userIDFromLocalStorage && userIDFromLocalStorage !== userID) {
      window.document.cookie = `UserID=${userIDFromLocalStorage};Max-Age=63158400;Domain=${domain};Path=/`;
      return;
    }

    if (!userID && !userIDFromLocalStorage && useStoreSsPlayer().isPlayerAuthorised) {
      saveUserId();
    }
  };

  const clear = () => {
    localStorage.setItem('UserID', '');
    window.document.cookie = ``;
  };

  return {
    init,
    saveUserId,
    checkUserId,
    clear,
  };
};
